export default {
      id: "fast-choose-period-usage",
      viewBox: "0 0 20 18",
      url: "assets/" + "sprite.svg#fast-choose-period-usage",
      toString: function () {
        return this.url;
      }
    }